
import { ref } from '@nuxtjs/composition-api'

export default {
  props: {
    isUpgrade: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const expand = ref(false)
    const upgrade = ref(false)

    return {
      upgrade,
      expand
    }
  }
}
